import * as React from 'react';
import successIcon from '../images/success-icon.svg';
import { T } from '@testout/labsim-ui-atomics';
import styles from './SuccessPage.module.less';
export default class SuccessPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement("img", { src: successIcon, height: 80 }),
            React.createElement(T.Text.H1, { automationId: 'title' }, "Success!"),
            React.createElement(T.Text.H2, { automationId: 'action' }, this.props.successAction),
            React.createElement("div", { className: 'desc' }, this.props.moreInfo),
            React.createElement("div", null,
                React.createElement(T.Button, { automationId: 'done', id: 'browseHomeButton', onClick: this.props.onClickCallback }, "Done"))));
    }
}
//# sourceMappingURL=SuccessPage.js.map